import { AscPathLoader, AscProjectsLoader } from '@neo.tax/asc/organisms';
import { Path } from '@neo.tax/shared';

import { useAscProjectsRedirect } from './hooks';

export const AscProjects = (): React.ReactElement => (
  <AscPathLoader path={Path.ASC_PROJECTS} useRedirect={useAscProjectsRedirect}>
    <AscProjectsLoader />
  </AscPathLoader>
);
